<template>
  <div id="TransmisionEnVivo_div" class="w-100 px-5 py-0">
    <div slot="title" class="offset-md-1">
      <h1 style="margin-bottom: 0px;">TRANSMISIÓN EN VIVO</h1>
      <h3 style="margin-top: 0px;">{{Audiencia.TipoDocumento.Nombre}} {{Audiencia.Consecutivo}} {{Audiencia.Sala.Nombre}} </h3>
    </div>
      <div class="row d-flex">
      <!--<div id="DespliegueVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-2 padding-div-low">
        <div class="area">
          <h2>Información</h2>
          <hr />
          <p><strong>Juzgado: </strong><br />{{Audiencia.Area.Nombre}}</p>
          <p><strong>Materia: </strong><br />{{Audiencia.Materia.Nombre}}</p>
          <p><strong>Tipo de documento: </strong><br />{{Audiencia.TipoDocumento.Nombre}}</p>
          <p><strong>Consecutivo: </strong><br />{{Audiencia.Consecutivo}}</p>
          <p>
            <strong>Jueces: </strong><br />
            <p v-for="(Juez,index) in Audiencia.JuecesEnAudiencia">{{index + 1}}.- {{Juez.Juez.Nombre}} {{Juez.Juez.ApellidoPaterno}} {{Juez.Juez.ApellidoMaterno}}</p>
          </p>
          <p><strong>Tipo de audiencia: </strong><br />{{Audiencia.TipoAudiencia.Nombre}}</p>
          <p><strong>Fecha y Hora: </strong><br />{{Audiencia.FechaAudiencia | fechaHora }}</p><br />
          <p><strong>Sala: </strong><br />{{Audiencia.Sala.Nombre}}</p>
        </div>
      </div> -->
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <!-- <div class="area"> -->
          <Reproductor :componentesDeCamaras="componentesDeCamaras" :reproducirVideo="false" :esEnVivo="true" :grabacion="false" :parametros="SesionActiva" :key="SesionActiva.Sala != undefined && SesionActiva.Sala != null ? SesionActiva.Sala.Nombre : 0"></Reproductor>
        <!-- </div> -->
      </div>
    </div>
    <audio ref="audio_forseti" :src='audioSource' type="audio/mp3" :controls='false' ></audio>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas';
  import api from '@/../static/js/api'
  import axios from 'axios'
  import moment from 'moment';

  export default {
    components: {
      Reproductor: sistemas.Forseti.Reproductor
    },
    data() {
      return {
        componentesDeCamaras: [],
        camaras: [
          { camaraId: enumeraciones.camaras.Juez },
          { camaraId: enumeraciones.camaras.Imputado },
          { camaraId: enumeraciones.camaras.Victima },
          { camaraId: enumeraciones.camaras.Testigos },
          { camaraId: enumeraciones.camaras.Protegido },
          { camaraId: enumeraciones.camaras.Publico },
          { camaraId: enumeraciones.camaras.Evidencias }
        ],
        SesionActiva: {},
        Audiencia: {
          Area: { Nombre: String },
          Materia: { Nombre: String },
          TipoAudiencia: {
            Nombre: String
          },
          TipoDocumento: {
            Nombre: ""
          },
          Fecha: String,
          HoraDeInicio: String,
          HoraFinalizada: String,
          Jueces: [
            { Nombre: String }
          ],
          Sala: { Nombre: "" },
          TipoEstatusDeAudiencia: {
            TipoEstatusDeAudienciaId: Number,
            Nombre: String
          },
          Consecutivo : ""        
        },
        audioSource: null
      }
    },
    props: {
      AudienciaId: Number
    },
    filters: {
      fechaHora(fecha) {
        return moment(String(fecha)).format('DD/MM/YYYY hh:mm');
      }
    },
    mounted() {
      this.busquedaAudiencia();
    },
    methods: {
      async busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.GetAudienciaFinalizada,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => { 
          if (respuesta.data.SiHayError) {             
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            this.Audiencia = respuesta.data.AudienciaFinalizada;
            this.SesionActiva = this.Audiencia.SesionesDeLasAudiencias.find(sesion => sesion.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 3);   
            setTimeout(()=>{
              const audio_audiencia = this.$refs.audio_forseti;
              audio_audiencia.src = respuesta.data.AudienciaFinalizada.Sala.IPDeTransmision;
              audio_audiencia.preload= "none";
              audio_audiencia.play();  
            },1500 );                   
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
    },
    beforeDestroy () {
        
      const audio_audiencia = this.$refs.audio_forseti;
      audio_audiencia.pause();
      audio_audiencia.src = '';
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Transmision/TransmisionEnVivo/ReproductorEnvivo.vue